import { IconButton, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { c } from '../../../theme/colorUtils';

export const StyledInput = styled(TextField)(({ theme }) => ({
  "&.MuiFormControl-root": {
    width: "100%",
  },
  "& .MuiInputBase-root": {
    width: "100%",
    background: c.bg01,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    "& input.MuiInputBase-input": {
      padding: "16px",
      fontSize: "0.875rem",
      color: c.text01,
      fontWeight: 400,
      lineHeight: "16.8px",
      "&::placeholder": {
        color: c.hard,
        opacity: 1,
      },
    },
    "&:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${c.text02}`,
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #909195",
    },
    "&.Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${c.text02}`,
      },
    },
    "&.Mui-error": {
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${c.error}`,
      },
    },
  },
}));

export const ErrorInputText = styled(Typography)(() => ({
  "&.MuiTypography-root": {
    fontSize: "0.625rem",
    fontWeight: 400,
    color: "#FE536B",
    lineHeight: "14px",
    textAlign: "left",
    marginTop: 3,
  },
}));

export const SearchIconButton = styled(IconButton)(() => ({
  "&.MuiIconButton-root": {
    padding: 0,
    paddingTop:4
  },
}));
